import React, { RefObject } from 'react';

import { Box, CSSObject, Stack, Text } from 'ui';
import { LogoGivebacksTMBlueSVG } from 'ui/Icons';

import { PRINT_FRAME_HEADER_ID } from './constants';
import { UsePrintty } from './types';

const HEADER_TEMPLATE_STYLES: CSSObject = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'top',
  padding: '10px 0',
  width: '100%',
};

interface PrintConstructorProps
  extends Partial<Pick<UsePrintty, 'HeaderElement' | 'headerProps'>> {}
/** Main header component attached to the print / pdf includes title/subtitle with the givebacks logo positioned to the far right  */
const HeaderTemplate = ({ HeaderElement, headerProps }: PrintConstructorProps) => {
  return (
    <div style={HEADER_TEMPLATE_STYLES}>
      <div>
        {HeaderElement && typeof HeaderElement === 'function' ? <HeaderElement /> : HeaderElement}
        {headerProps && (
          <>
            <Stack gap="4">
              {headerProps?.title && (
                <Text fz={12} fw={500} c="cobalt.8">
                  {headerProps.title}
                </Text>
              )}
              {headerProps?.subTitle && (
                <Text fz={20} fw="600">
                  {headerProps.subTitle}
                </Text>
              )}
            </Stack>
          </>
        )}
      </div>
      <div>
        <img src={LogoGivebacksTMBlueSVG} width={120} height={25} alt="Givebacks Logo" />
      </div>
    </div>
  );
};
const PrintHeader = ({ Element }: { Element: UsePrintty['HeaderInfoBoxElement'] }) => {
  if (!Element) return null;
  return <Box>{typeof Element === 'function' ? <Element /> : Element}</Box>;
};

const PrintConstructor = ({
  contentRef,
  HeaderElement,
  headerProps,
  HeaderInfoBoxElement,
  content,
  targetMargin,
}: PrintConstructorProps & {
  content?: React.ReactNode;
  contentRef: RefObject<HTMLDivElement>;
  HeaderInfoBoxElement?: UsePrintty['HeaderInfoBoxElement'];
  // Target margin in pixels around the content
  targetMargin?: number;
}) => {
  return (
    <Stack gap={0} m={targetMargin}>
      <Stack gap="sm" mb="sm" id={PRINT_FRAME_HEADER_ID}>
        <HeaderTemplate HeaderElement={HeaderElement} headerProps={headerProps} />
        <PrintHeader Element={HeaderInfoBoxElement} />
      </Stack>

      <table>
        {content && content}
        <div dangerouslySetInnerHTML={{ __html: contentRef.current?.innerHTML ?? `` }} />
      </table>
    </Stack>
  );
};

export { PrintConstructor };
